import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonIconButton from '../../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../../icons';
import ErrorElement from './ErrorElement';

import scss from './ErrorList.module.scss';

function ErrorList({ errors, onClose }) {
  const { t } = useTranslation('activ8');

  return (
    <div className={scss.errorList}>
      <div className={scss.header}>
        <span className={scss.title}>{t('errors')}</span>
        <CommonIconButton icon={ICONS.Cross} onClick={onClose} isStrokeIcon iconClassName={scss.closeIcon} />
      </div>

      <ul className={scss.list}>
        {errors.map(({ errors, file }, index) => (
          <li key={`${file.name}-${index}`}>
            <ErrorElement errorCode={errors[0].code} fileName={file.name} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ErrorList;
